import { call, put, takeEvery } from 'redux-saga/effects';
import { SendApiRequest } from 'src/api';
import { apiRoutes } from 'src/api/routes';
import {
    fetchSettings,
    settingsFetched,
    settingsFetchedFailed,
} from '../settings';

function* fetchSettingsEffect() {
    try {
        const response = yield call(SendApiRequest, {
            url: apiRoutes.settings,
            method: 'GET',
            queryParams: {},
        });
        yield put(
            settingsFetched({
                results: response.results,
            }),
        );
    } catch (e) {
        yield put(settingsFetchedFailed());
    }
}

export const appSettingsSagas = [
    takeEvery(fetchSettings.type, fetchSettingsEffect),
];
